import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled ? 'bg-black/80 backdrop-blur-md border-zinc-800 py-4' : 'bg-transparent border-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        <div className="text-xl font-bold tracking-tighter flex items-center gap-2">
          <div className="w-2 h-2 bg-cyan-500 rounded-full"></div>
          phoinix<span className="text-zinc-500">.tech</span>
        </div>
        
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-zinc-400">
          <a href="#expertise" className="hover:text-white transition-colors">Expertise</a>
          <a href="#philosophy" className="hover:text-white transition-colors">Philosophy</a>
          <button className="bg-white text-black px-5 py-2 rounded-full hover:bg-zinc-200 transition-colors">
            Initiate Project
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;